'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import { IconClose } from '@sympla/sympla-components';

import { getMainUrlOrganizer } from 'utils/misc';
import { addEventToDataLayer } from 'utils/addEventToDataLayer';

import * as styles from './MobileCTACreateEventBanner.css';

interface MobileCTABannerProps {
  isMobile?: boolean;
  handleCloseBanner?: () => void;
  isDark?: boolean;
}

export function MobileCTACreateEventBanner({ isMobile = false, handleCloseBanner, isDark = false }: MobileCTABannerProps) {
  const [showBanner, setShowHideBanner] = useState(isMobile);
  useEffect(() => {
    if (!showBanner && isMobile && handleCloseBanner) handleCloseBanner();
  }, [showBanner]);

  if (!showBanner || !isMobile) return null;

  return (
    <div className={`${styles.mobileCTABanner} ${isDark ? styles.mobileCTABannerDark : ''}`}>
      <p className={styles.text}>É Produtor?</p>
      <Link
        id="btn-create-event-mobile"
        href={`${getMainUrlOrganizer()}/criar-evento`}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.mobileCTAButton} ${isDark ? styles.mobileCTAButtonDark : ''}`}
        onClick={() => {
          addEventToDataLayer({
            stckEventCategory: 'home_clique_header',
            stckEventLabel: 'btn-create-event-mobile',
          });
        }}
      >
        Criar evento
      </Link>
      <Link
        id="btn-how-it-works-mobile"
        href="https://produtores.sympla.com.br/como-funciona/"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.btnHowItWorks}
        onClick={() => {
          addEventToDataLayer({
            stckEventCategory: 'home_clique_header',
            stckEventLabel: 'btn-how-it-works-mobile',
          });
        }}
      >
        Como funciona
      </Link>
      <button aria-label="Fechar notificação do produtor" className={styles.buttonClose} type="button" onClick={() => setShowHideBanner(false)}>
        <IconClose />
      </button>
    </div>
  );
}
